import PropTypes from 'prop-types'

export const antennaShape = PropTypes.shape({
    id: PropTypes.number,
    code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // n° immobilisation (l'antenne stocke l'immo dans 'code')
    name: PropTypes.string,
    comment: PropTypes.string,
    antenneType: PropTypes.number,
    materielType: PropTypes.number, // alias de antenneType
    purchaseDate: PropTypes.number,
    manufactureDate: PropTypes.number,
    providerId: PropTypes.number,
    serialNumber: PropTypes.string,
    updateDate: PropTypes.number,
    updateLogin: PropTypes.string,
    loginReferent: PropTypes.string,
    manufacturerId: PropTypes.number,
    administrator: PropTypes.number,
    networkCode: PropTypes.number,
    location: PropTypes.string,
    owner: PropTypes.number,
    shared: PropTypes.bool,
    installationCategory: PropTypes.number,
    mobilityCode: PropTypes.number,
    jobExecutionId: PropTypes.number,
    warantyLength: PropTypes.number,
    supplyTime: PropTypes.number,
    cableLength: PropTypes.number,
    locationSituation: PropTypes.string,
})
